export const METHODS_AND_DATA_TABS = [
  { label: "methods", slug: "methods" },
  { label: "data glossary", slug: "data-glossary" },
  { label: "faqs", slug: "faqs" },
  { label: "data download", slug: "data-download" },
]

export const SPANISH_METHODS_AND_DATA_TABS = [
  { label: "métodos", slug: "methods" },
  { label: "glosario de datos", slug: "data-glossary" },
  { label: "guías y faqs", slug: "faqs" },
  { label: "descarga de datos", slug: "data-download" },
]
